// extracted by mini-css-extract-plugin
export default {"colors":"\"../../../../../../styles/variables/colors.module.css\"","color-red400":"#e11e1d","color-white":"#ffffff","wrapper":"UserMenuToggle_wrapper__W6RLt"};